/**
 * The amount of milliseconds to exponentially increase
 */
export const INTERVAL_MILLIS = 500 // 0.5 sec

/**
 * The factor to backoff by
 */
export const BACKOFF_FACTOR = 2

/**
 * The maximum milliseconds to increase to
 */
export const BACKOFF_LIMIT_MILLIS = 10 * 60 * 1000 // 10 min

/**
 * The percentage of backoff time to randomize by
 */
export const RANDOM_FACTOR = 0.2

/**
 * List of fatal errors for Request Policy
 * @see https://setplexapps.atlassian.net/wiki/spaces/MW/pages/3430776834/Request+Policy#Failure-Conditions
 *
 *  - 408 Request Timeout
 *  - 413 Content Too Large
 *  - 429 Too Many Requests
 *  - 502 Bad Gateway
 *  - 503 Service Unavailable
 *  - 504 Gateway Timeout
 *  - 521 (Cloudflare) Web Server Is Down
 *  - 522 (Cloudflare) Connection Timed Out
 *  - 523 (Cloudflare) Origin Is Unreachable
 *  - 524 (Cloudflare) A Timeout Occurred
 *  - 529 (Qualys) The service is overloaded
 *  - 598 (Informal convention) Network read timeout error
 *  - 599 Network Connect Timeout Error
 */
export const FATAL_ERRORS = [408, 413, 429, 502, 503, 504, 521, 522, 523, 524, 529, 598, 599] // biome-ignore format: one line

/**
 * List of retriable errors:
 * @see https://setplexapps.atlassian.net/wiki/spaces/MW/pages/2682454084/Retry+Policy#Response-codes
 *
 *  - 408 Request Timeout
 *  - 413 Content Too Large
 *  - 429 Too Many Requests
 *  - 500 Internal Server Error <- not fatal, but retriable
 *  - 502 Bad Gateway
 *  - 503 Service Unavailable
 *  - 504 Gateway Timeout
 */
export const RETRIABLE_ERRORS = [408, 413, 429, 500, 502, 503, 504]

/**
 * List of retriable http methods
 * Until backend doesn't support idempotency, retries only applies to default idempotent requests
 * https://developer.mozilla.org/en-US/docs/Glossary/Idempotent
 */
export const RETRIABLE_METHODS = [
  'GET',
  'PUT',
  'HEAD',
  'DELETE',
  'OPTIONS',
  'TRACE',
]

/**
 * Retries count (1 means -> 1 request + 1 retry)
 */
export const RETRY_LIMIT = 1

/**
 * Limit time for all retries combined,
 * this is essentially a total timeout for single request, with all retries under the hood included
 */
export const TOTAL_RETRY_LIMIT_MILLIS = 1 * 60 * 1000 // 1 min

/**
 * Debounce time for persisting request buckets
 * This is used to reduce the number of writes to the localStorage
 */
export const PERSIST_REQUEST_POLICY_BUCKETS_DEBOUNCE = 1000 // 1 sec
